import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider[7]}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5, 2, 1.75, 2),
  transition: 'all .5s ease',
  backgroundColor: theme.palette.secondary.main,
  backdropFilter: `blur(${theme.spacing(1)})`,
  marginBottom: theme.spacing(2),
  '&:hover': {
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: 'pointer',
  },
  '&.LCActive': {
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: 'pointer',
  },
  '& .LCAdressLink': {
    display: 'flex',
    color: theme.palette.common.white,
    gap: theme.spacing(1.2),
    marginBottom: theme.spacing(2.75),
  },
  '& .LCAddressIcon': {
    fontSize: theme.spacing(3),
    color: theme.palette.common.white,
  },
  '& .LCAdressLabel': {
    color: theme.palette.text.secondary,
  },
  '& .LCActionsContainer': {
    display: 'flex',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  '& .LCAction': {
    padding: 0,
    minHeight: 'unset',
    '& .LCActionIcon': {
      fontSize: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
  },

}));
export default StyledBox;